import React from 'react'
import styled from '@emotion/styled'
import ParameterValue from 'components/ParameterValue'

const withStyle = (LogicNode) => {
  const StyledOutputNode = styled(LogicNode)`
    margin-bottom: 20px;
    width: 305px;
    position: relative;

    label {
      display: block;
      font-size: 12px;
      font-weight: bold;
      margin: 1em 0 0 0;
    }
  `

  return (props) => <StyledOutputNode {...props} />
}

export default withStyle

export const StyledContentInner = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  pointer-events: none;
  position: relative;
  width: 100%;
`

export const OutputValueRow = styled(ParameterValue)`
  display: block;
  padding: 6px 0;
`
